<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;">
      <div class="pure-g">
        <div class="pure-u-2-3">
          <div class="pure-g">
            <div class="pure-u-1-5">
              <div class="whiteBox dashboard_number">
                <h4>待处理线索
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="统计值包含DCC线索管理平台中待处理的线索，若与门店待处理线索不一致，则存在部分线索正在由DCC线索管理平台处理中"
                  >
                    <i
                      class="fa fa-question-circle-o"
                      aria-hidden="true"
                      slot="reference"
                    ></i>
                  </el-popover>
                </h4>
                <h3>{{ summaryTotal.waitingClearCount }}</h3>
                <div class="desc"></div>
              </div>
            </div>
            <div class="pure-u-1-5">
              <div class="whiteBox dashboard_number">
                <h4>待完成任务</h4>
                <h3>{{ summaryTotal.pendingTaskCount }}</h3>
                <div class="desc"></div>
              </div>
            </div>
            <div class="pure-u-1-5">
              <div class="whiteBox dashboard_number">
                <h4>逾期待完成任务</h4>
                <h3>{{ summaryTotal.delayTaskCount }}</h3>
                <div class="desc"></div>
              </div>
            </div>
            <div class="pure-u-1-5">
              <div class="whiteBox dashboard_number">
                <h4>今日完成任务</h4>
                <h3>{{ summaryTotal.todayCompletedTaskCount }}</h3>
                <div class="desc">
                  <span
                    >昨日: {{ summaryTotal.yesterdayCompletedTaskCount }}</span
                  >
                  <i :class="getRateIcon(summaryTotal.completedTaskRate)"
                    >{{ summaryTotal.completedTaskRate }}%</i
                  >
                </div>
              </div>
            </div>
            <div class="pure-u-1-5">
              <div class="whiteBox dashboard_number">
                <div>
                  3平台平均清洗时长
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content=""
                  >
                    <div>
                      <div>仅统计本月（截止T-1天）线索清洗开始时间在09:00-17:59 、18:00-19:59（新疆经销商除外）这两个时间段内，由汽车之家、易车、懂车帝3平台流入线索的平均清洗时长（第一次有效/无效/未接通的时间-线索进入商家系统的时间），等同王朝、海洋商家首次回访时长数据。</div>
                      <div v-if="summaryTotal.filterClearSecondsDateInfos">
                        <div style="margin-top: 5px; font-weight: 550;">本月统计已剔除以下日期范围：</div>
                        <div v-for="(item, index) in summaryTotal.filterClearSecondsDateInfos" :key="index">{{ formatFilterDate(item) }}</div>
                      </div>
                    </div>
                    <i
                      class="fa fa-question-circle-o"
                      aria-hidden="true"
                      slot="reference"
                    ></i>
                  </el-popover>
                </div>
                <div style="margin: 0 -15px; font-size: 10px; border-bottom: 1px solid #444;">09:00-17:59 <span style="font-weight: 600;font-size: 12px;">{{ MillisecondToDate(summaryTotal.averageClearSeconds1) }}</span></div>
                <div style="margin: 0 -15px; font-size: 10px;">18:00-19:59 <span style="font-weight: 600;font-size: 12px;">{{ MillisecondToDate(summaryTotal.averageClearSeconds2) }}</span></div>
              </div>
            </div>
            <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <h4>今日新增线上客户</h4>
                <h3>{{ summaryTotal.todayNewOnlineCustomerCount }}</h3>
                <div class="desc">
                  <span
                    >昨日:
                    {{ summaryTotal.yesterdayNewOnlineCustomerCount }}</span
                  >
                  <i :class="getRateIcon(summaryTotal.newOnlineCustomerRate)"
                    >{{ summaryTotal.newOnlineCustomerRate }}%</i
                  >
                </div>
              </div>
            </div>
            <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <h4>今日新增线下客户</h4>
                <h3>{{ summaryTotal.todayNewStoreCustomerCount }}</h3>
                <div class="desc">
                  <span
                    >昨日:
                    {{ summaryTotal.yesterdayNewStoreCustomerCount }}</span
                  >
                  <i :class="getRateIcon(summaryTotal.newStoreCustomerRate)"
                    >{{ summaryTotal.newStoreCustomerRate }}%</i
                  >
                </div>
              </div>
            </div>

            <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <h4>今日订车</h4>
                <h3>{{ summaryTotal.todayOrderCount }}</h3>
                <div class="desc">
                  <span>昨日: {{ summaryTotal.yesterdayOrderCount }}</span>
                  <i :class="getRateIcon(summaryTotal.orderRate)"
                    >{{ summaryTotal.orderRate }}%</i
                  >
                </div>
              </div>
            </div>
            <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <h4>团队成员</h4>
                <h3>{{ summaryTotal.memberCount }}</h3>
                <div class="desc" v-if="summaryTotal.invalidMemberCount > 0">
                  <span>未激活: {{ summaryTotal.invalidMemberCount }}</span>
                </div>
              </div>
            </div>
            <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <div>
                  三大垂媒线索到店率
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="仅统计本月（截止T-1天）由汽车之家、易车、懂车帝三大垂媒平台的线索到店率，到店数以客流统计到店数为准"
                  >
                    <i
                      class="fa fa-question-circle-o"
                      aria-hidden="true"
                      slot="reference"
                    ></i>
                  </el-popover>
                </div>
                <h3 style="font-size:20px">
                  {{ `${arrivalRateEs}%` }}
                </h3>
                <div class="desc"></div>
              </div>
            </div>
            <!-- <div class="pure-u-1-5" style="margin-top:15px;">
              <div class="whiteBox dashboard_number">
                <h4>
                  2平台平均清洗时长
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="仅统计本月在9：00-18：00时间段，由汽车之家、e购商城2平台留入线索的平均清洗时长（第一次有效/无效/未接通的时间-线索进入商家系统的时间），等同体验中心首次回访时长数据。"
                  >
                    <i
                      class="fa fa-question-circle-o"
                      aria-hidden="true"
                      slot="reference"
                    ></i>
                  </el-popover>
                </h4>
                <h3 style="font-size:20px">
                  {{ MillisecondToDate(summaryTotal.averageClearSeconds2) }}
                </h3>
                <div class="desc"></div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="pure-u-1-3">
          <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
              <i class="el-icon-d-arrow-right">&nbsp;</i>最新公告
            </div>
            <div
              class="portlet-content"
              style="height: 138px;overflow-y: auto;"
            >
              <span v-if="dealerProfile.topic == ''">还未留下公告...</span>
              <span
                style="display:block;width: 100%;
    word-wrap: break-word;"
                >{{ dealerProfile.topic }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="pure-g" style="margin-top:15px;height:400px;">
        <div class="pure-u-2-3">
          <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
              <i class="el-icon-d-arrow-right">&nbsp;</i>趋势分析
            </div>
            <div class="portlet-content" v-loading="trendChartLoading">
              <div id="trendChart"></div>
            </div>
          </div>
        </div>
        <div class="pure-u-1-3">
          <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
              <div class="pure-g">
                <div class="pure-u-1-2">
                  <i class="el-icon-d-arrow-right">&nbsp;</i>客户分布TOP 10
                </div>
                <div class="pure-u-1-2" style="text-align:right;">
                  <span
                    :class="customerDateType == 4 ? '' : 'click_link'"
                    @click="retrieveCustomerData(4)"
                    >今日</span
                  >
                  <span
                    :class="customerDateType == 3 ? '' : 'click_link'"
                    @click="retrieveCustomerData(3)"
                    >本周</span
                  >
                  <span
                    :class="customerDateType == 2 ? '' : 'click_link'"
                    @click="retrieveCustomerData(2)"
                    >本月</span
                  >
                  <span
                    :class="customerDateType == 1 ? '' : 'click_link'"
                    @click="retrieveCustomerData(1)"
                    >本年</span
                  >
                  <span
                    :class="customerDateType == 0 ? '' : 'click_link'"
                    @click="retrieveCustomerData(0)"
                    >所有</span
                  >
                </div>
              </div>
            </div>
            <div class="portlet-content" v-loading="customerChartLoading">
              <div id="customerChart"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="pure-g" style="margin-top:35px;height:400px;">
        <div class="pure-u-1-2">
          <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
              <div class="pure-g">
                <div class="pure-u-1-2">
                  <i class="el-icon-d-arrow-right">&nbsp;</i>线上渠道分布
                </div>
                <div class="pure-u-1-2" style="text-align:right;">
                  <span
                    :class="onlineSourceDateType == 4 ? '' : 'click_link'"
                    @click="retrieveOnlineSourceData(4)"
                    >今日</span
                  >
                  <span
                    :class="onlineSourceDateType == 3 ? '' : 'click_link'"
                    @click="retrieveOnlineSourceData(3)"
                    >本周</span
                  >
                  <span
                    :class="onlineSourceDateType == 2 ? '' : 'click_link'"
                    @click="retrieveOnlineSourceData(2)"
                    >本月</span
                  >
                  <span
                    :class="onlineSourceDateType == 1 ? '' : 'click_link'"
                    @click="retrieveOnlineSourceData(1)"
                    >本年</span
                  >
                  <span
                    :class="onlineSourceDateType == 0 ? '' : 'click_link'"
                    @click="retrieveOnlineSourceData(0)"
                    >所有</span
                  >
                </div>
              </div>
            </div>
            <div class="portlet-content" v-loading="onlineSourceChartLoading">
              <div id="onlineSourceChart"></div>
            </div>
          </div>
        </div>
        <div class="pure-u-1-2">
          <div class="whiteBox dashboard_topic">
            <div class="portlet-title">
              <div class="pure-g">
                <div class="pure-u-1-2">
                  <i class="el-icon-d-arrow-right">&nbsp;</i>线下客户来源
                </div>
                <div class="pure-u-1-2" style="text-align:right;">
                  <span
                    :class="storeSourceDateType == 4 ? '' : 'click_link'"
                    @click="retrieveStoreSourceData(4)"
                    >今日</span
                  >
                  <span
                    :class="storeSourceDateType == 3 ? '' : 'click_link'"
                    @click="retrieveStoreSourceData(3)"
                    >本周</span
                  >
                  <span
                    :class="storeSourceDateType == 2 ? '' : 'click_link'"
                    @click="retrieveStoreSourceData(2)"
                    >本月</span
                  >
                  <span
                    :class="storeSourceDateType == 1 ? '' : 'click_link'"
                    @click="retrieveStoreSourceData(1)"
                    >本年</span
                  >
                  <span
                    :class="storeSourceDateType == 0 ? '' : 'click_link'"
                    @click="retrieveStoreSourceData(0)"
                    >所有</span
                  >
                </div>
              </div>
            </div>
            <div class="portlet-content" v-loading="storeSourceChartLoading">
              <div id="storeSourceChart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import { Chart } from "@antv/g2";
import { MillisecondToDate } from "../../filters/index";
import dayjs from "dayjs";
export default {
  data() {
    return {
      dealer: this.$common.getDealer(),
      dealerProfile: {
        topic: "",
      },
      summaryTotal: {},
      arrivalRateEs: 0, // 三大垂媒有效线索到店率
      chartData: [],

      trendChart: {},
      trendChartLoading: false,

      customerChart: {},
      customerChartLoading: false,
      customerDateType: 4,
      customerData: [],

      onlineSourceChart: {},
      onlineSourceChartLoading: false,
      onlineSourceDateType: 4,
      onlineSourceData: [],

      storeSourceChart: {},
      storeSourceChartLoading: false,
      storeSourceDateType: 4,
      storeSourceData: [],
    };
  },
  mounted() {
    this.retrieveDealerProfile();
    this.retrieveSummary();
    this.queryArrivalRateEs();
    this.renderTrendChart();
    this.renderCustomerChart();
    this.renderOnlineSourceChart();
    this.renderStoreSourceChart();
  },
  methods: {
    retrieveDealerProfile() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/profile", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.dealerProfile = response.data;
        })
        .catch(() => {});
    },
    MillisecondToDate(val) {
      return MillisecondToDate(val);
    },
    retrieveSummary() {
      var parent = this;
      this.$httpAuth
        .post("/v1/reportRpc/dashboardSummary", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.summaryTotal = response.data;
        })
        .catch(() => {});
    },
    formatFilterDate(item) {
      const { startDate, endDate } = item;
      return `${dayjs.unix(startDate).format('YYYY-MM-DD')}~${dayjs.unix(endDate).format('YYYY-MM-DD')}；`
    },
    queryArrivalRateEs() {
      const data = dayjs()
      const startDate = data.startOf('month').format('YYYY-MM-DD HH:mm:ss')
      const endDate = dayjs().format('YYYY-MM-DD 23:59:59')
      this.$httpAuth
        .post("/v2/v2DealerReportRpc/ArrivalRateEs", {
          startDate: dayjs(startDate).unix(), // 开始时间，秒
          endDate: dayjs(endDate).unix(),// 结束时间，秒
          isExport: false,// 是否导出
          dealerId: this.dealer.dealerId,
        })
        .then((response)=> {
          this.arrivalRateEs = response.data?.rate || 0;
        })
        .catch(() => {});
    },
    getRateIcon(rate) {
      if (rate == 0) {
        return "el-icon-caret-left black";
      }
      if (rate > 0) {
        return "el-icon-caret-top red";
      }
      if (rate < 0) {
        return "el-icon-caret-bottom green";
      }
      return "";
    },
    renderTrendChart() {
      var chart = new Chart({
        container: "trendChart",
        forceFit: true,
        height: 350,
      });
      chart.source(this.chartData);
      chart.tooltip({
        crosshairs: {
          type: "line",
        },
      });
      chart.axis("count1", {
        label: {
          formatter: function formatter(val) {
            return val;
          },
        },
      });
      chart
        .line()
        .position("name*count1")
        .color("column1")
        .shape("smooth");
      chart
        .point()
        .position("name*count1")
        .color("column1")
        .size(4);
      // .shape({
      //   stroke: "#fff",
      //   lineWidth: 1,
      // });
      chart.render();

      this.trendChart = chart;
      this.retrieveTrendData();
    },
    retrieveTrendData() {
      var parent = this;
      parent.trendChartLoading = true;
      this.$httpAuth
        .post("/v1/reportRpc/dashboardTrend", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.trendChart.changeData(response.data.data);
          parent.trendChartLoading = false;
        })
        .catch(() => {
          parent.trendChartLoading = false;
        });
    },
    renderCustomerChart() {
      var chart = new Chart({
        container: "customerChart",
        forceFit: true,
        height: 350,
      });
      chart.source(this.chartData);
      chart.tooltip({
        itemTpl: "<li>客户数: {value}</li>",
      });
      chart.coord().transpose();
      chart.interval().position("name*count1");
      chart.render();

      this.customerChart = chart;
      this.retrieveCustomerData(this.customerDateType);
    },
    retrieveCustomerData(dateType) {
      this.customerDateType = dateType;
      var parent = this;
      parent.customerChartLoading = true;
      this.$httpAuth
        .post("/v1/reportRpc/dashboardCustomer", {
          dealerId: this.dealer.dealerId,
          dateType: dateType,
        })
        .then(function(response) {
          var data = response.data.data;
          data.sort(function(a, b) {
            var comparison = 0;
            if (a.count1 > b.count1) {
              comparison = 1;
            } else if (a.count1 < b.count1) {
              comparison = -1;
            }
            return comparison;
          });
          if (data.length > 10) {
            parent.customerChart.changeData(
              data.slice(data.length - 10, data.length)
            );
          } else {
            parent.customerChart.changeData(data);
          }

          parent.customerData = data;
          parent.customerChartLoading = false;
        })
        .catch(() => {
          parent.customerChartLoading = false;
        });
    },
    renderOnlineSourceChart() {
      var chart = new Chart({
        container: "onlineSourceChart",
        forceFit: true,
        height: 350,
        animate: false,
      });
      chart.source(this.chartData);
      chart.tooltip({
        itemTpl: "<li>线索量: {value}</li>",
      });
      // var tickInterval = 50;
      // chart.scale('count1', {
      //     tickInterval: tickInterval
      // });
      chart.interval().position("name*count1");
      chart.render();

      this.onlineSourceChart = chart;
      this.retrieveOnlineSourceData(this.onlineSourceDateType);
    },
    retrieveOnlineSourceData(dateType) {
      this.onlineSourceDateType = dateType;
      var parent = this;
      parent.onlineSourceChartLoading = true;
      this.$httpAuth
        .post("/v1/reportRpc/dashboardOnlineSource", {
          dealerId: this.dealer.dealerId,
          dateType: dateType,
        })
        .then(function(response) {
          var data = response.data.data;
          data.sort(function(a, b) {
            var comparison = 0;
            if (a.count1 > b.count1) {
              comparison = -1;
            } else if (a.count1 < b.count1) {
              comparison = 1;
            }
            return comparison;
          });
          parent.onlineSourceChart.changeData(data);
          parent.onlineSourceData = data;
          parent.onlineSourceChartLoading = false;
        })
        .catch(() => {
          parent.onlineSourceChartLoading = false;
        });
    },
    renderStoreSourceChart() {
      var chart = new Chart({
        container: "storeSourceChart",
        forceFit: true,
        height: 350,
        animate: false,
      });
      chart.source(this.chartData);
      chart.tooltip({
        itemTpl: "<li>线索量: {value}</li>",
      });
      // var tickInterval = 50;
      // chart.scale('count1', {
      //     tickInterval: tickInterval
      // });
      chart.interval().position("name*count1");
      chart.render();

      this.storeSourceChart = chart;
      this.retrieveStoreSourceData(this.storeSourceDateType);
    },
    retrieveStoreSourceData(dateType) {
      this.storeSourceDateType = dateType;
      var parent = this;
      parent.storeSourceChartLoading = true;
      this.$httpAuth
        .post("/v1/reportRpc/dashboardStoreSource", {
          dealerId: this.dealer.dealerId,
          dateType: dateType,
        })
        .then(function(response) {
          var data = response.data.data;
          data.sort(function(a, b) {
            var comparison = 0;
            if (a.count1 > b.count1) {
              comparison = -1;
            } else if (a.count1 < b.count1) {
              comparison = 1;
            }
            return comparison;
          });
          parent.storeSourceChart.changeData(data);
          parent.storeSourceData = data;
          parent.storeSourceChartLoading = false;
        })
        .catch(() => {
          parent.storeSourceChartLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.dashboard_number {
  margin-right: 10px;
}
</style>
